// Screen width
export const ScreenWidth = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
}